import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Customers.css';

function Customers() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [formData, setFormData] = useState({
    customer_code: '',
    name: '',
    email: '',
    phone: '',
    tax_no: '',
    tax_office: '',
    address: '',
    contact_person: '',
    active: true
  });

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/customers');
      setCustomers(response.data.data);
    } catch (error) {
      console.error('Müşteriler yüklenemedi:', error);
      alert('Müşteriler yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (customer = null) => {
    if (customer) {
      setEditingCustomer(customer);
      setFormData({
        customer_code: customer.customer_code || '',
        name: customer.name || '',
        email: customer.email || '',
        phone: customer.phone || '',
        tax_no: customer.tax_no || '',
        tax_office: customer.tax_office || '',
        address: customer.address || '',
        contact_person: customer.contact_person || '',
        active: customer.active !== undefined ? customer.active : true
      });
    } else {
      setEditingCustomer(null);
      setFormData({
        customer_code: '',
        name: '',
        email: '',
        phone: '',
        tax_no: '',
        tax_office: '',
        address: '',
        contact_person: '',
        active: true
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingCustomer(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Backend camelCase bekliyor, dönüştür
      const submitData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        taxNo: formData.tax_no,
        taxOffice: formData.tax_office,
        contactPerson: formData.contact_person,
        active: formData.active
      };
      
      if (editingCustomer) {
        submitData.customer_code = formData.customer_code;
        await api.put(`/customers/${editingCustomer.id}`, submitData);
        alert('Müşteri güncellendi!');
      } else {
        await api.post('/customers', submitData);
        alert('Müşteri eklendi!');
      }
      handleCloseModal();
      fetchCustomers();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu müşteriyi silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/customers/${id}`);
      alert('Müşteri silindi');
      fetchCustomers();
    } catch (error) {
      alert('Silme hatası: ' + (error.response?.data?.message || 'Hata'));
    }
  };

  if (loading) {
    return (
      <div className="loading-page">
        <div className="loading-spinner"></div>
        <p>Müşteriler yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="customers-page">
      <div className="page-header">
        <h1>👥 Müşteri Yönetimi</h1>
        <div className="header-actions">
          <button className="btn-back" onClick={() => navigate('/dashboard')}>
            ← Dashboard
          </button>
          <button className="btn-primary" onClick={() => handleOpenModal()}>
            ➕ Yeni Müşteri
          </button>
        </div>
      </div>

      {customers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">👥</div>
          <h3>Henüz Müşteri Yok</h3>
          <p>İlk müşterinizi ekleyerek başlayın</p>
          <button className="btn-primary" onClick={() => handleOpenModal()}>
            ➕ İlk Müşteriyi Ekle
          </button>
        </div>
      ) : (
        <div className="customers-table-wrapper">
          <table className="customers-table">
            <thead>
              <tr>
                <th>Kod</th>
                <th>Müşteri Adı</th>
                <th>Email</th>
                <th>Telefon</th>
                <th>Vergi No</th>
                <th>İlgili Kişi</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id}>
                  <td><strong>{customer.customer_code || '-'}</strong></td>
                  <td>{customer.name}</td>
                  <td>{customer.email || '-'}</td>
                  <td>{customer.phone || '-'}</td>
                  <td>{customer.tax_no || '-'}</td>
                  <td>{customer.contact_person || '-'}</td>
                  <td>
                    <span className={`status-badge ${customer.active ? 'status-active' : 'status-inactive'}`}>
                      {customer.active ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => handleOpenModal(customer)} title="Düzenle">
                        ✏️
                      </button>
                      <button className="btn-delete" onClick={() => handleDelete(customer.id)} title="Sil">
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{editingCustomer ? '✏️ Müşteri Düzenle' : '➕ Yeni Müşteri'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                {editingCustomer && (
                  <div className="form-group">
                    <label>Müşteri Kodu</label>
                    <input
                      type="text"
                      value={formData.customer_code}
                      disabled
                      style={{opacity: 0.6, cursor: 'not-allowed'}}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Müşteri Adı *</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    placeholder="ATP Makine"
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    placeholder="info@atpmakine.com"
                  />
                </div>
                <div className="form-group">
                  <label>Telefon</label>
                  <input
                    type="text"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    placeholder="0312 XXX XX XX"
                  />
                </div>
                <div className="form-group">
                  <label>Vergi No</label>
                  <input
                    type="text"
                    value={formData.tax_no}
                    onChange={(e) => setFormData({...formData, tax_no: e.target.value})}
                    placeholder="1234567890"
                  />
                </div>
                <div className="form-group">
                  <label>Vergi Dairesi</label>
                  <input
                    type="text"
                    value={formData.tax_office}
                    onChange={(e) => setFormData({...formData, tax_office: e.target.value})}
                    placeholder="Çankaya"
                  />
                </div>
                <div className="form-group">
                  <label>İlgili Kişi</label>
                  <input
                    type="text"
                    value={formData.contact_person}
                    onChange={(e) => setFormData({...formData, contact_person: e.target.value})}
                    placeholder="Ahmet Yılmaz"
                  />
                </div>
                <div className="form-group full-width">
                  <label>Adres</label>
                  <textarea
                    value={formData.address}
                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                    rows="3"
                    placeholder="Tam adres..."
                  />
                </div>
                <div className="form-group full-width">
                  <div className="checkbox-group">
                    <input
                      type="checkbox"
                      id="active"
                      checked={formData.active}
                      onChange={(e) => setFormData({...formData, active: e.target.checked})}
                    />
                    <label htmlFor="active">Aktif Müşteri</label>
                  </div>
                </div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={handleCloseModal}>
                  İptal
                </button>
                <button type="submit" className="btn-submit">
                  {editingCustomer ? '✓ Güncelle' : '✓ Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Customers;
